import { Action } from "@reduxjs/toolkit";
import { isType } from "typescript-fsa";
import { groupActions } from "./actions";
import { GroupState } from "./types";

const initialState: GroupState = {
  groups: null,
};

export function GroupReducer(state = initialState, action: Action): GroupState {
  if (isType(action, groupActions.fetchGroups.done)) {
    return {
      ...state,
      groups: action.payload.result.data.map((group) => ({
        id: group.id,
        name: group.name,
        clientName: group.customer_name,
      })),
    };
  }

  if (isType(action, groupActions.resetToInitialState)) {
    return initialState;
  }

  return state;
}
